const state = {
    type: null,
    message: null
};

const actions = {
    success({ commit }: { commit: any }, message: any) {
        commit('success', message);
    },
    error({ commit }: { commit: any }, message: any) {
        commit('error', message);
    },
    clear({ commit }: { commit: any }) {
        commit('clear');
    }
};

const mutations = {
    success(state: any, message: any) {
        state.type = 'success';
        state.message = message;
    },
    error(state: any, message: any) {
        state.type = 'error';
        state.message = message;
        window.scroll(0, 0);
    },
    clear(state: any) {
        state.type = null;
        state.message = null;
    }
};

export const alert = {
    namespaced: true,
    state,
    actions,
    mutations
};
